import React from 'react';
import InlineEditBase from './InlineEditBase';

interface InlineEditTextareaProps {
  value: string | undefined;
  onSave: (value: string | number) => Promise<void> | void;
  onCancel?: () => void;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  rows?: number;
  label?: string;
}

const InlineEditTextarea: React.FC<InlineEditTextareaProps> = ({
  value,
  onSave,
  onCancel,
  disabled = false,
  className = '',
  placeholder,
  rows = 4,
  label,
}) => {
  return (
    <InlineEditBase
      value={value}
      onSave={(val) => onSave(typeof val === 'string' ? val : String(val))}
      onCancel={onCancel}
      disabled={disabled}
      className={className}
    >
      {({ isEditing, value: editValue, onChange, onSave, onCancel, inputRef }) => {
        if (!isEditing) {
          return (
            <div className="whitespace-pre-wrap text-[var(--color-default-font)]">
              {value || <span className="text-[var(--color-neutral-400)] italic">Not set</span>}
            </div>
          );
        }

        return (
          <div className="animate-slide-down">
            {label && <label className="block text-sm font-medium text-[var(--color-default-font)] mb-1">{label}</label>}
            <textarea
              ref={inputRef as React.RefObject<HTMLTextAreaElement>}
              value={editValue.toString()}
              onChange={(e) => onChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Escape') {
                  e.preventDefault();
                  onCancel();
                }
              }}
              placeholder={placeholder}
              rows={rows}
              className="w-full px-3 py-2 border border-[var(--color-neutral-border)] rounded-md bg-[var(--color-default-background)] text-[var(--color-default-font)] focus:outline-none focus:ring-2 focus:ring-[var(--color-brand-500)] resize-y"
            />
          </div>
        );
      }}
    </InlineEditBase>
  );
};

export default InlineEditTextarea;

